import { render, staticRenderFns } from "./AscAlertIcon.vue?vue&type=template&id=837c5c9c&"
import script from "./AscAlertIcon.vue?vue&type=script&lang=js&"
export * from "./AscAlertIcon.vue?vue&type=script&lang=js&"
import style0 from "./AscAlertIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports